export class LocationProfile {
    readonly INTERNAL = 'INTERNAL';
    readonly EXTERNAL = 'EXTERNAL';
    readonly CLIMATE = 'CLIMATE';
    readonly CLIMATE_CHANGE = 'CLIMATE_CHANGE';
    readonly APG = 'APG';
    readonly NRI = 'NRI';
    readonly POI = 'POI';
    readonly AIR_QUALITY = 'AIR_QUALITY';
    readonly CONDITIONS = 'CONDITIONS';
    readonly FORECASTS = 'FORECASTS';
    readonly TROPICALCYCLONES = 'TROPICALCYCLONES';
    readonly ALERTS = 'ALERTS';
    readonly CONVECTIVE_AND_OUTLOOK = 'CONVECTIVE_AND_OUTLOOK';
    readonly DROUGHTS_AND_MONITOR = 'DROUGHTS_AND_MONITOR';
    readonly FIRES = 'FIRES';
    readonly FIRES_AND_OUTLOOK = 'FIRES_AND_OUTLOOK';
    readonly PLACES = 'PLACES';
    readonly RIVERS = 'RIVERS';
    readonly STROMCELLS = 'STROMCELLS';
    readonly THREATS = 'THREATS';
//    readonly TENSORFLIGHT = 'TENSORFLIGHT';
    readonly E2VALUE = 'E2VALUE';
    readonly COMBINED = 'COMBINED';
    readonly MUNICHRE = 'MUNICHRE';
    readonly MUNICHRE_REPORT = 'MUNICHRE_REPORT';
    readonly CUSTOM_SCORE = 'CUSTOM_SCORE';
    readonly FORMULA = 'FORMULA';
    readonly PRECISELY_BUILDING = 'PRECISELY_BUILDING';
    readonly PRECISELY_CRIME = 'PRECISELY_CRIME';
    readonly PRECISELY_WILDFIRE_RISK = 'PRECISELY_WILDFIRE_RISK';
}

export enum dropdownMenuList {
    INTERNAL = 'Internal',
    //  AIR_QUALITY = 'Air Quality',
    //  ALERTS = 'Alerts',
    CLIMATE = 'Climate IPCC',
    CLIMATE_CHANGE = 'Climate Change',
    //  CONVECTIVE_AND_OUTLOOK = 'Convective/Outlook',
    //  DROUGHTS_AND_MONITOR = 'Droughts/Monitor',
    EXTERNAL= 'External',
    //  FIRES = 'Fires',
    //  FIRES_AND_OUTLOOK = 'Fires/Outlook',
    //  FORECASTS = 'Forecasts',
    MUNICHRE = 'Munich Re',
    NRI = 'NRI',
    POI = 'POI',
    APG = 'Precisely Wildfire',
    //  RIVERS = 'Rivers',
    //  STROMCELLS = 'Stormcells',
 //   TENSORFLIGHT = 'TensorFlight',
    E2VALUE = 'E2Value',
    //  TROPICALCYCLONES = 'Tropicalcyclones',
    // THREATS = 'Threats',
    CONDITIONS = 'Xweather conditions',
    PLACES = 'Xweather places',
    CUSTOM_SCORE = 'Custom Score',
    FORMULA = 'Formula',
    PRECISELY_BUILDING = 'Precisely COPE',
    PRECISELY_CRIME = 'Precisely Crime',
    PRECISELY_WILDFIRE_RISK = 'Precisely Wildfire Risk'
}

export enum addressProfileDropdownMenuList {
    EXTERNAL = 'External',
    CLIMATE = 'Climate IPCC',
    CLIMATE_CHANGE = 'Climate Change',
    NRI = 'NRI',
    POI = 'POI',
    APG = 'Precisely Wildfire',
    CONDITIONS = 'XWeather Conditions',
    PLACES = 'XWeather Places',
    PRECISELY_BUILDING = 'Precisely COPE',
    PRECISELY_CRIME = 'Precisely Crime',
    PRECISELY_WILDFIRE_RISK = 'Precisely Wildfire Risk'
}

//export const TENSORFLIGHT_ARRAY = ['TENSORFLIGHT', 'Tensorflight']
export const PRECISELY_BUILDING_ARRAY = ['PRECISELY_BUILDING', 'Precisely COPE']
export const PRECISELY_CRIME_ARRAY = ['PRECISELY_CRIME', 'Precisely Crime']
export const PRECISELY_WILDFIRE_RISK_ARRAY = ['PRECISELY_WILDFIRE_RISK', 'Precisely Wildfire Risk']
export const MUNICHRE_ARRAY = ['MUNICHRE', 'Munich Re Natural Hazard']
export const MUNICHRE_REPORT_ARRAY = ['MUNICHRE_REPORT', 'Munich Re Climate Change Report']

export enum ExternalDataFetchingAPIKeys{
    //TENSORFLIGHT = "tensorflight",
    PRECISELY_BUILDING = "precisely_building",
    PRECISELY_CRIME = "precisely_crime",
    PRECISELY_WILDFIRE_RISK = "precisely_wildfire_risk",
    MUNICHRE = "munichre_hazards"
}

//export const TENSORFLIGHT_POLYGON_DATA_KEY = "polygon_data";
// The mapper writes this id; it arrives bare in a see-info payload and prefixed with the
// dataset key on a datapoint, so call sites match it with endsWith.
export const PRECISELY_BUILDING_GEOMETRY_KEY = "geometry_coordinates";

/**
 * Precisely's blockGroupCode - a 12-digit Census GEOID - used to fetch and draw the location's
 * block group boundary while the Precisely Crime profile is selected.
 */
export const PRECISELY_CRIME_BLOCK_GROUP_KEY = "precisely_crime_block_group_code";

/**
 * Which Census block group vintage the code above belongs to. Sent with the boundary request so
 * the backend draws from a matching layer: block groups are renumbered at each decennial census,
 * and a code paired with the wrong vintage's boundaries draws a wrong shape with no error.
 */
export const PRECISELY_CRIME_VINTAGE_KEY = "precisely_crime_vintage";
export const EMPTY_PROFILE = "EMPTY_PROFILE"

